import { render, staticRenderFns } from "./allTable.vue?vue&type=template&id=2f773a92&scoped=true"
import script from "./allTable.vue?vue&type=script&lang=ts"
export * from "./allTable.vue?vue&type=script&lang=ts"
import style0 from "./allTable.vue?vue&type=style&index=0&id=2f773a92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f773a92",
  null
  
)

export default component.exports